import React from 'react'
import AddSalesManager from './AddSalesManager';

const EditSalesManager = (props) => {
  return (
    <AddSalesManager uuid={props.match.params.uuid} />
  )
}

export default EditSalesManager;